import { useTranslation } from '@eti/providers';
import { Inline, Stack, Text } from '@etg/wings';
import { Check } from '@phosphor-icons/react';
import { css } from '@eti/styles';

const inlineItemStyles = css`
  flex: 1;
`;

const getListItemsFromHtml = (htmltext: string): string[] => {
  const parser = new DOMParser();
  const htmlText = parser.parseFromString(htmltext, 'text/html');
  const listItems = htmlText.getElementsByTagName('li');
  return [...listItems].map((item) => item.innerHTML);
};

interface ListItemsProps {
  dataTestId: string;
  htmlTextKey: string;
}

const CheckListItems = ({ dataTestId, htmlTextKey }: ListItemsProps) => {
  const { t } = useTranslation();

  const listItems = getListItemsFromHtml(t(htmlTextKey));

  return listItems.length > 0 ? (
    <Stack data-testid={dataTestId} role="list" spacing={8}>
      {listItems.map((item, index) => (
        <Inline key={item} role="listitem" spacing={8}>
          <Check
            aria-hidden="true"
            color="#0a6600"
            data-testid={`${dataTestId}-${index}-checklist-icon`}
            size="1.25rem"
            weight="bold"
          />
          <Text
            asHtml
            className={inlineItemStyles}
            data-testid={`${dataTestId}-${index}-checklist-item`}
          >
            {item}
          </Text>
        </Inline>
      ))}
    </Stack>
  ) : (
    <Text asHtml data-testid={`${dataTestId}-checklist-non-list-text`}>
      {t(htmlTextKey)}
    </Text>
  );
};

export default CheckListItems;
